<template>
	<el-dialog :visible="true" title="修改任务" width="600px" @close="$emit('close')">
		<el-form :model="formData" label-width="80px">
			<el-form-item label="标题">
				<el-input v-model="formData.title" style="width:70%" placeholder="请输入标题" />
			</el-form-item>
			<el-form-item label="支付方式">
				<el-select v-model="formData.pay_type" style="width:70%" placeholder="">
					<el-option label="线上线下支付" :value="0" />
					<el-option label="仅线下支付" :value="1" />
                    <el-option label="仅线上支付" :value="2" />
				</el-select>
			</el-form-item>
		</el-form>
		<span slot="footer">
			<el-button :disabled="loading" @click="$emit('close')">取 消</el-button>
			<el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { book_mission } from '@/api/book'
	export default {
		props: ['mission'],
		data() {
			return {
				loading: false,
				formData: {
					id: this.mission.id,
					title: this.mission.title || '',
					pay_type: this.mission.pay_type || 0
				}
			}
		},
		methods: {
			submit() {
				this.loading = true
				book_mission.edit(this.formData).then(res => {
					this.$emit('success')
					this.$message.success("设置成功")
					this.loading = false
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/book/bookmanage/edit-mission-form.vue